import React from "react";

function ContainerWrapper({ children }) {
  return <div className="containerWrapper">{children}</div>;
}

export default ContainerWrapper;
